module.exports = __webpack_public_path__ + "static/img/son6_active.5cd4f443.png";